module.exports = "<header>\n  <span class=\"subtitle\">{{'VACATIONS_ABSENCES.TEAM_REQUESTS.COINCIDENCES.TITLE' | translate}}</span>\n  <h1>\n    <a ng-hide=\"$ctrl.hidePrevArrow()\" href=\"\" ng-click=\"$ctrl.prevMonth()\">&lt;</a>\n    <span class=\"title\">{{$ctrl.monthName}}</span>\n    <a href=\"\" ng-click=\"$ctrl.nextMonth()\">&gt;</a>\n  </h1>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator.html
// module id = 1487
// module chunks = 0